import axiosInstance from '../axiosConfig';

export default {
  async validateReferral(payload) {
    const response = await axiosInstance.post('EcomValidaReferido', payload);
    return response.data;
  },
};
